import React from 'react';
import useSelectDevices from '@root/hooks/giftCard/useSelectDevice';
import SelectUnbindDevices from '../SelectUnbindDevices';
import { useTranslation } from 'react-i18next';

const SelectDevice = () => {
  const {
    state: { selected, maxDevNum, paying, payMark, payMethodState },
    action: { onSelected, onClickPay },
  } = useSelectDevices();
  const { t } = useTranslation();

  return (
    <SelectUnbindDevices
      selected={selected}
      maxDevNum={maxDevNum}
      onChange={onSelected}
      paying={paying}
      onClickPay={onClickPay}
      payMethodState={payMark ? payMethodState : undefined}
      btnText={t('purchase_now')}
    />
  );
};

export default SelectDevice;
